module.exports = __webpack_public_path__ + "media/images/products/products/modal/1-94d5f7486d743925be269ba7d4709b3d.jpg";